// Copied directly from viu-schema-data
export const MOCKED_ATTRIBUTION_SCHEMAS_FROM_FILE: Record<string, any>[] = [
    {
        "schema_type": "AGGREGATOR",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/aggregator.json",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "AggregatorAttribution",
            "type": "object",
            "properties": {
                "coreAccountId": {
                    "type": "string",
                    "format": "uuid"
                },
                "tollFreeNumber": {
                    "type": "string"
                },
                "recordSource": {
                    "type": "string",
                    "enum": ["VIU", "Referral"],
                    "default": "VIU"
                }
            },
            "required": [
                "coreAccountId",
                "tollFreeNumber",
                "recordSource"
            ]
        }
    },
    {
        "schema_type": "CAMPAIGN",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/campaign.json",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "CampaignAttribution",
            "type": "object",
            "properties": {
                "source": {
                    "type": "string"
                },
                "medium": {
                    "type": "string"
                },
                "content": {
                    "type": "string"
                },
                "campaign": {
                    "type": "string"
                }
            },
            "required": [
                "source",
                "medium",
                "content",
                "campaign"
            ]
        }
    },
    {
        "schema_type": "PARTNER",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/partner.json",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "PartnerAttribution",
            "type": "object",
            "properties": {
                "coreAccountId": {
                    "type": "string",
                    "format": "uuid"
                },
                "tollFreeNumber": {
                    "type": "string"
                },
                "recordSource": {
                    "type": "string",
                    "enum": ["VIU", "Referral"],
                    "default": "Referral"
                },
                "landingPageActive": {
                    "type": "boolean",
                    "default": false
                },
                "landingPageUrl": {
                    "type": "string"
                }
            },
            "required": [
                "coreAccountId",
                "tollFreeNumber",
                "recordSource",
                "landingPageActive"
            ]
        }
    },
    {
        "schema_type": "CAMPAIGN_MEDIUM",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/campaign/medium",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "CampaignMediumAttribution",
            "type": "object",
            "properties": {
                "medium": {
                    "type": "string"
                }
            },
            "required": ["medium"]
        }
    },
    {
        "schema_type": "CAMPAIGN_SOURCE",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/campaign/source",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "CampaignSourceAttribution",
            "type": "object",
            "properties": {
                "source": {
                    "type": "string"
                }
            },
            "required": ["source"]
        }
    },
    {
        "schema_type": "CAMPAIGN_CONTENT",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/campaign/content",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "CampaignContentAttribution",
            "type": "object",
            "properties": {
                "content": {
                    "type": "string"
                }
            },
            "required": ["content"]
        }
    },
    {
        "schema_type": "BORROWER",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/borrower",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "BorrowerAttribution",
            "type": "object",
            "properties": {
                "borrowerId": {
                    "type": "string"
                }
            },
            "required": ["borrowerId"]
        }
    },
    {
        "schema_type": "AGENT_ID",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/agent/id",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "AgentId",
            "type": "object",
            "properties": {
                "agentId": {
                    "type": "string"
                }
            },
            "required": ["agentId"],
            "additionalProperties": false
        }
    },
    {
        "schema_type": "AGENT_NAME",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/agent/name",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "AgentName",
            "type": "object",
            "properties": {
                "agentName": {
                    "type": "string"
                }
            },
            "required": ["agentName"],
            "additionalProperties": false
        }
    },
    {
        "schema_type": "ORIGINATING_CAMPAIGN",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/originating-campaign",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "OriginatingCampaign",
            "type": "object",
            "properties": {
                "originatingCampaign": {
                    "type": "string"
                }
            },
            "required": ["originatingCampaign"],
            "additionalProperties": false
        }
    },
    {
        "schema_type": "SEMSEE_IDENTIFICATION",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/semsee-identification.json",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "type": "object",
            "title": "SemseeIdentification",
            "properties": {
                "partnerAgencyId": {
                    "type": "string",
                    "title": "Partner Agency Id"
                }
            },
            "required": ["partnerAgencyId"]
        }
    },
    {
        "schema_type": "PARTNER",
        "schema_type_version": 2,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/partner",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "PartnerAttribution",
            "type": "object",
            "properties": {
                "coreAccountId": {
                    "type": "string",
                    "format": "uuid"
                },
                "tollFreeNumber": {
                    "type": "string"
                },
                "recordSource": {
                    "type": "string",
                    "enum": ["VIU", "Referral"],
                    "default": "Referral"
                },
                "landingPageActive": {
                    "type": "boolean",
                    "default": false
                },
                "landingPageUrl": {
                    "type": "string"
                },
                "productRoutingActive": {
                    "type": "boolean",
                    "default": true
                }
            },
            "required": [
                "coreAccountId",
                "tollFreeNumber",
                "recordSource",
                "landingPageActive"
            ]
        }
    },
    {
        "schema_type": "CAMPAIGN",
        "schema_type_version": 2,
        "schema": {
            "$id": "https://viu-schema-data/schema/attribution/campaign",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "CampaignAttribution",
            "type": "object",
            "properties": {
                "campaign": {
                    "type": "string"
                }
            },
            "required": ["campaign"]
        }
    }
];